<template>
        <div>
        <div slot="content" class="homepage">
            <div class="TableDetails" id="content">
                <el-table :data="tableData" border style="width: 100%" @sort-change="sortChange">
                    <el-table-column prop="productid" label="书目id" width="120px" align="center"> </el-table-column>
                    <el-table-column prop="cisbn" label="书号(订单)" width="140px" align="center"> </el-table-column>
                    <el-table-column prop="c200a" label="书名(订单)" align="center"> </el-table-column>
                    <el-table-column prop="c210c" label="出版社(订单)" width="200px" align="center"> </el-table-column>
                    <el-table-column prop="unitprice" label="单价(订单)" width="100px" align="center">
                    </el-table-column>
                    <el-table-column prop="salesvolume" label="册数" width="100px" align="center"> </el-table-column>
                    <el-table-column prop="subscriptionno" label="征订号" width="240px" align="center">
                    </el-table-column>
                    <el-table-column prop="statusname" label="状态" sortable width="120px" align="center"> </el-table-column>
                </el-table>
            </div>
            <div class="fr">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="pageNum" :page-size="pageSize" layout="prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Row,
    Col,
    Form,
    FormItem,
    Input,
    Button,
    Notification,
    Checkbox,
    DatePicker,
    CheckboxGroup,
    Select,
    Option,
} from "element-ui";
import Axios from "@/api/diyaxioscopy.js";
export default {
    name: "OrderDetails",
    data() {
        return {
            tableData: [],
            pageSize: 10,
            pageNum: 1,
            total: 100,
            pages: {
                startindex: 1,
                pageindex: 10,
                orderby: ''
            },
        };
    },
    components: {
    },
    mounted() {
        this.Apitotal();
        this.ApiData();
    },
    methods: {
        //排序
        sortChange(column) {
            let vm = this, orderby = '';
            if (column.order == 'descending') {
                orderby = column.prop + ' desc';
            } else if (column.order == 'ascending') {
                orderby = column.prop + ' asc';
            }
            vm.pages.orderby = orderby;
            vm.Apitotal();
            vm.ApiData(); //更新列表
        },
        // 检索
        onSubmit() {
            let vm = this;
            vm.Apitotal();
            vm.ApiData();
            // queryFormData = JSON.parse(JSON.stringify(vm.tempform));
            // vm.$emit("submitForm", queryFormData);
        },
        // 获取数据
        ApiData() {
            let vm = this,
                url = "/sxerp/pt/erpservice/rsalesorder/getDetailsBySalesid";
                var obj = {
                    salesid: vm.$route.query.salesid,
                    orderby: "",
                    c210c: vm.$route.query.c210c,
                    xkid: vm.$route.query.xkid,
                    startindex: vm.pageNum,
                    pageindex: vm.pageSize,
                };
            // vm.pages.salesid = vm.$route.query.salesid;
            Axios.post(
                url,
                {params:obj},
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            ).then((res) => {
                console.log(res,'resss');
                if (res.data.length > 0) {
                    this.tableData = res.data;
                } else {
                    vm.isNonedata = true;
                }
            }).catch((err) => { });
        },
        // 获取总条数
        Apitotal() {
            let vm = this,
                url = "/sxerp/pt/erpservice/rsalesorder/getDetailsBySalesid_count";
                var obj = {
                    salesid: vm.$route.query.salesid,
                    orderby: "",
                    c210c: vm.$route.query.c210c,
                    xkid: vm.$route.query.xkid,
                    startindex: vm.pageNum,
                    pageindex: vm.pageSize,
                };
            // vm.pages.salesid = vm.$route.query.salesid; 
            Axios.post(
                url,
               {params:obj},
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            ).then((res) => {
                if (res.data > 0) {
                    vm.total = res.data;
                } else {
                    vm.total = 0;
                }
            }).catch((err) => { });
        },
        // 分页
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pageSize = val
            this.ApiData();
            this.Apitotal();
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.pageNum = val;
            this.ApiData();
            this.Apitotal();
        },
    },
};
</script>

<style lang="scss">
.homepage {
    height: 1000px;
    #content {
        margin: 0px auto 0px auto;
        position: relative;
    }

    .el-table {
        text-align: center;
        margin-bottom: 30px;
    }
}
/* /deep/.el-table .el-table__cell {
    padding: 4px 0;
    text-align: center;
    color: #787676;
} */
</style>


// WEBPACK FOOTER //
// src/views/Xtch/wuliumanage/OrderDetails.vue